import { Layout } from "antd";
import NewNavBar from "../newHome/NewNavBar/NewNavBar";
import { useMediaQuery } from "react-responsive";

export const TopTemaplete = ({ routes }) => {
  const { Header, Content, Footer, Sider } = Layout;
  const isMobile = useMediaQuery({ maxWidth: 992 });

  return (
    <>
      <Layout>
        <Header className={"main-header"}>
          <NewNavBar />
        </Header>
        <Content className={"content-menu-user"}>{routes}</Content>
      </Layout>
    </>
  );
};
